import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'react-jss'

import JsonObject from './json-object'

import consoleStyles from './debug-console-style'

const DebugConsole = props => {
  const formatMessage = (message, i) => {
    switch(typeof message) {
      case 'string':
        return i === 0 ? message : ` — ${message}`
      case 'object':
        return <JsonObject className={props.classes.json} message={message} key={i} index={i} />
      default:
        return i === 0 ? JSON.stringify(message) : ` — ${JSON.stringify(message)}`
    }
  }

  return (
    <div className={props.classes.container}>
      <div className={props.classes.title} onClick={props.toggleMessages}>
        Debug console
        {props.isExpanded && props.messages.length > 0 &&
          <button className={props.classes.clearButton} onClick={props.clearMessages}>Clear log</button>
        }
      </div>
      {props.isExpanded &&
        <div>
          {props.messages.map((attrs, i) =>
            <div className={props.classes.message} key={i}>
              <span className={props.classes.number}>{i}:</span> {attrs.map(formatMessage)}
            </div>
          )}
        </div>
      }
    </div>
  )
}

DebugConsole.propTypes = {
  messages: PropTypes.array.isRequired,
  isExpanded: PropTypes.bool,
  toggleMessages: PropTypes.func.isRequired,
  clearMessages: PropTypes.func.isRequired,
}

export default withStyles(consoleStyles)(DebugConsole)
